import './LlmChatView.css';
import React from 'react';
import { baseUrl_PB, baseUrl_SPB } from '../BaseUrl';
import { useAuth } from '../AuthProvider';
export const AI_AGENT_EMAIL = 'ai-agent@effiez.com.au';

export default function LlmChatView(props) {
    const authContext = useAuth();
    const [messages, setMessages] = React.useState([]);
    const [conversationheads, setConversationheads] = React.useState([]);
    const [input, setInput] = React.useState("");
    const sessions = ['New Chat', 'Zul Al-Kabir', 'Robbie Rahman', 'Maliha Rahnuma'];
    const ai_agent = { other_user: 'Your assistant', convoId: '123' };
    const [otheruserref, setOtheruserref] = React.useState([]);
    const [convoId, setConvoId] = React.useState(null);
    const timer = React.useRef(null);

    React.useEffect(() => {
        setMessages([]);
        const newMessage = { convoId: null, message_content: "What are you thinking...",user_email:AI_AGENT_EMAIL,ctimestamp:new Date().toISOString() };
        setMessages([newMessage]);
        setConvoId(null);
         const email=authContext && authContext.additionalUserInfo?authContext.additionalUserInfo.email:'';
        fetch(`${baseUrl_PB}/loadconversationheads?user_email=${email}`)
            .then(response => response.json())
            .then(data => {
                data = data.map((convohead) => {
                    return { id: convohead.convoId, heading: ""+convohead.heading, chats: convohead.other_user };


                })

                setConversationheads(data);
            })
            .catch(error => {
                console.error('Error fetching initial messages:', error);
            });
    }, []);
    React.useEffect(() => {
        timer.current = (setInterval((convoId) => {
            loadconversation(convoId, otheruserref)
        }, 4000));
        if (convoId === null) {
            clearInterval(timer.current);
        }
        return () => {
            clearInterval(timer.current);
        };
    }, [convoId]);

    const loadconversationheads = () => {
        const email=authContext && authContext.additionalUserInfo?authContext.additionalUserInfo.email:'';
        fetch(`${baseUrl_PB}/loadconversationheads?user_email=${email}`)
            .then(response => response.json())
            .then(data => {
                
                data = data.map((convohead) => {
                    return { id: convohead.convoId, heading: ""+convohead.heading, chats: convohead.other_user };


                })

                setConversationheads(data);
            })
            .catch(error => {
                console.error('Error fetching initial messages:', error);
            });
    }
    const loadconversation = (convoId, other_user) => {
        if (convoId == null) {
            return;
        }
        setOtheruserref(other_user)
        fetch(`${baseUrl_PB}/loadconversation?convoId=${convoId}`)
            .then(response => response.json())
            .then(data => {
                setMessages(data);
                setConvoId(data[0].convoId);
            })
            .catch(error => {
                console.error('Error fetching initial messages:', error);
            });
    }

    const newtask = () => {
        setMessages([]);
        const newMessage = { convoId: null, message_content: "What are you thinking?...",user_email:AI_AGENT_EMAIL,ctimestamp:new Date().toISOString() };
        setMessages([newMessage]);
        setConvoId(null);

    }
    const handleSend = (e) => {
        e.preventDefault();
         const email=authContext && authContext.additionalUserInfo?authContext.additionalUserInfo.email:'You';
        if ((otheruserref != undefined && otheruserref.length > 0 && otheruserref.includes("ai-agent")) || (messages[0] && messages[0].convoId == null)) {

            if (input.trim() === "") return;
            const inputmessage = { message_content: input ,user_email:email,ctimestamp:new Date().toISOString()};
            setMessages([...messages, inputmessage, { message_content: 'Checking...few moments please...' ,user_email:AI_AGENT_EMAIL,ctimestamp:new Date().toISOString()}]);

            const combinedQuery = input;
            let postData = { "inputs": combinedQuery, "user_email": email,"convoId":convoId,
                "parameters": {
    "max_new_tokens": 1024,
    "do_sample": true,
    "temperature": 0.7,
    "top_p": 0.9
  }
             }
            fetch(`https://dc8ie5bs0m.execute-api.ap-southeast-2.amazonaws.com/beta-v1`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(postData),

            })
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    if(data.convoId){
                        setConvoId(data.convoId);
                        loadconversationheads();
                        loadconversation(convoId, otheruserref);
                    }
                    if(data.question){
                        const newMessage = { message_content: data.question,user_email:AI_AGENT_EMAIL,ctimestamp:new Date().toISOString() };
                        setMessages([...messages, inputmessage,newMessage]);
                        loadconversationheads();
                        loadconversation(convoId, otheruserref);
                    }else{
                        const newMessage = { message_content: data[0].generated_text,user_email:AI_AGENT_EMAIL,ctimestamp:new Date().toISOString() };
                        setMessages([...messages, inputmessage,newMessage]);
                        loadconversationheads();
                        loadconversation(convoId, otheruserref);
                    }
                    setInput("");
                })
                .catch(error => {
                    console.error('Error:', error);
                });

            setInput("");
        }
        else {

            if (input.trim() === "") return;
            const newMessage = { message_content: input };
            setMessages([...messages, newMessage, { message_content: 'Checking...few moments please...'  }]);
            const combinedQuery = input;

            let postData = { "inputs": combinedQuery, "user_email": authContext.additionalUserInfo.email, "convoId": messages[0]?.convoId }
            fetch(`https://dc8ie5bs0m.execute-api.ap-southeast-2.amazonaws.com/beta-v1`, {
                method: 'POST',
                body: JSON.stringify(postData),

            })
                .then(response => response.json())
                .then(data => {
                    loadconversation(convoId, otheruserref);
                    const newMessage = { message_content: data };
                    //setMessages([...messages, newMessage]);
                    setInput("");
                })
                .catch(error => {
                    console.error('Error:', error);
                });

            setInput("");
        }
    };
    const convertTime = (time) => {
        const date = new Date(time);
        if (isNaN(date.getTime())) {
            return "Invalid date";
        }
        return date.toISOString().replace('T', ' ').substring(0, 19);
    }
    return (
        <div className="chat-container">
            <div className="chat-sessions">
                
                <ul>
                    <li className="new-task" onClick={() => newtask()} >New  +</li>
                </ul>
                <div className="task-chat-panel-container">
                   
                </div>
            </div>
            <div className="chat-content">
                <div className="chat-log">
                    {messages.map((msg, index) => (
                        <div key={index} className={`chat-message ${msg.user_email === '' ? 'chat-message-right' : 'chat-message-left'}`}>
                        <p className={`chat-query ${msg.user_email === '' ? 'chat-query-right' : 'chat-query-left'}`}><strong>{msg.user_email}:</strong> </p>
                        {msg.message_content}
                    </div>
                    ))}
                </div>
                <div className="chat-input-container">
                    <form onSubmit={handleSend} className="chat-form">
                        <div className="input-wrapper">
                        <input
                                type="text"
                                value={input}
                                onChange={(e) => setInput(e.target.value)}
                                placeholder={props.type === 'c' ? "What are you thinking..." : ""}
                                className="chat-input"
                            />
                            <button type="submit" className="chat-button">Send</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}